// extracted by mini-css-extract-plugin
export default {"routeContainer":"route-container__routeContainer--BCeoG"};